<div>
  <h3>{{ title }}</h3>
  <small>{{ subtitle }}</small>

  <div class="reflection" *ngFor="let question of questions" [ngSwitch]="question.type">
    <div *ngSwitchCase="reflectionQuestionType.textArea">
      <h5 class="sp-mt-32 sp-mb-12">{{ question.text }}</h5>
      <rich-text-editor [text]="question.answer" [readOnly]="readOnly"></rich-text-editor>
    </div>
  </div>

  <h5 class="sp-mt-32 sp-mb-12">My Key Results updates for this week</h5>

  <div [ngClass]="{ 'sp-mb-12': !last }" *ngFor="let krUpdate of krUpdates; let last = last">
    <ui-icon uiTheme="fill" uiType="metric" class="fs-16px sp-mr-12"></ui-icon>
    <span class="title">{{ krUpdate.title }}</span>
  </div>

  <button class="sp-mt-32" ui-button uiShape="round" uiType="primary" uiSize="large" [disabled]="true">Publish</button>
</div>
